/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
import utils from 'fizzy-ui-utils';

export function chartsSlider() {
  var slider = document.querySelector('.charts__slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    adaptiveHeight: true
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.charts__slider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }

  // flkty.on( 'settle', function( index ) {
  //   if (index = 1) {
  //     donutSpendGraph();
  //   }
  // });

  var buttonGroup = document.querySelector('.charts__nav');
  var buttons = buttonGroup.querySelectorAll('.charts__navLi');
  buttons = utils.makeArray( buttons );

  buttonGroup.addEventListener( 'click', function( event ) {
    // filter for button clicks
    // if ( !matchesSelector( event.target, '.charts__navLi' ) ) {
    //   return;
    // }
    var index = buttons.indexOf( event.target );
    flkty.select( index );

    // buttons.forEach(function (button) {
    //   button.classList.remove('active');
    // });

    // element.classList.add('active');
  });
}
